<div class="modal-container">
  <div class="site-logo"></div>
  <h2>Inactivity Detected</h2>
  <p>You have been inactive for a while.<br> Please refresh the page.</p>
  <button type="button" mat-raised-button (click)="onRefreshPageClick()">Refresh</button>
</div>
